import React from 'react';
import styled from 'styled-components';
import { theme } from 'styled-tools';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from './FacebookIcon';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

export const SocialLinksContainer = styled.div`
  margin: 2rem 0 0 0;
`;

const SocialLink = styled.a`
  font-size: 2rem;
  padding: 0 0.7rem;
  color: ${theme('colors.black')};

  &:hover {
    color: ${theme('colors.ttRed')};
    background-color: ${theme('colors.iconHoverBackgroundGray')};
    border-radius: 50%;
  }
`;

const SOCIAL_ICONS = {
  'Twitter': TwitterIcon,
  'Instagram': InstagramIcon,
  'Facebook': FacebookIcon,
  'LinkedIn': LinkedInIcon,
}

function SocialLinks({ data }) {
  const { social } = data

  return <SocialLinksContainer>
    {social && social.map((socialLink, idx) => {
        const ThisIcon = SOCIAL_ICONS[socialLink.name];
        return (
          <SocialLink key={idx} href={socialLink.url} target='_blank'>
            <ThisIcon/>
          </SocialLink>);
      }
    )}
  </SocialLinksContainer>
}

export default SocialLinks;